import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-rfid-search',
  templateUrl: './rfid-search.component.html',
  styleUrls: ['./rfid-search.component.css']
})
export class RfidSearchComponent implements OnInit {
    public setting?: Setting;

    public itemsListRfids: Item[] = [];

    public searchTextButtons: FormButton[] = [
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.searchRfids() }
    ];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1771))[0];
    }

    private async loadRfids() {
        if (!!this.setting) {
            this.itemsListRfids = await this.datatask.Post(1772, { searchtext: this.setting.searchtext });
        }
    }

    public searchRfids() {
        this.loadRfids();
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'searchtext':
                if (this.setting?.searchtext === '') {
                    this.itemsListRfids = [];
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadRfids();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
